import api from '../api'

export default {
  get (lat, lng, timestamp = Math.floor(Date.now() / 1000)) {
    console.log(timestamp)
    return api.authenticatedRequest('get', `/external-data/weather?lat=${lat}&lng=${lng}&date=${timestamp}`)
  }
}



// WEBPACK FOOTER //
// ./src/weather/index.js